<template>
	<div>
		<div @dragover.prevent @drop="uploadFile" class="dropFile">
			<div v-if="!getIsUploading" class="dropFile__drop-message">Drop a video file here to upload</div>
			<div v-if="getIsUploading" class="dropFile__drop-message">Video is uploading</div>
		</div>
		<progress-bar :val="uploadProgress"></progress-bar>
	</div>
</template>

<script>

	import { UPLOAD_S3_MEDIA } from '@/store/actions/upload'
	import ProgressBar from 'vue-simple-progress'

	import routes from '@/router'
	
	import { mapGetters } from 'vuex'

	export default {

		name: 'VideoUploader',

		components: {
			ProgressBar
		},

		computed:{
			...mapGetters(['getUploadsInProgress', 'getIsUploading']),
			hasUploadedFile(){
				return ( this._uid in this.getUploadsInProgress )
			},
			uploadProgress(){
				if(this._uid in this.getUploadsInProgress){
					return this.getUploadsInProgress[this._uid].progress
				}else{
					return 0
				}
			}

		},

		methods:{
			uploadFile(e){
				e.stopPropagation();
				e.preventDefault();
				var dt    = e.dataTransfer;
				var files = dt.files;
				var file = files[0];
				var fileName = file.name.replace(/ /g,'')
				if(file.type.match("video")){
					this.$emit('file-added', fileName)
					this.$store.dispatch(UPLOAD_S3_MEDIA, {
						name: fileName,
						type: file.type,
						forRepository:routes.app.$route.params.repoName,
						forComponent:this.$parent.$vnode.componentOptions.tag,
						file: file,
						fromComponent: this
					})
				}
			}
		}

	}
</script>

<style lang="scss" scoped>

	@import '@/scss/style.scss';
	
	.dropFile{
		border: 2px solid #e5e5e5;
		display:block;
		width: 100%;
		height: 100px;
		&__drop-message{
			color: #777;
			margin: 2em 0;
			text-align: center;
		}
	}

	.backgroundImage{
		padding: 20px 0;
	}
	h5{
		padding-bottom: 10px;
	}

	label {
		display: block;
	}

	html {
		font-size: 16px;
	}

	.btn:not(:last-of-type) {
		margin-right: 15px;
	}
	
</style>